/**
 * Mock client profile for the Coaching Dashboard v2 shell (spec §6, §8.5).
 * Role/sprint/goal/targets have no real data source yet — every field here
 * is throwaway review scaffolding, never wired to the database.
 */

export interface ClientElo {
  /** Current rating. */
  rating: number
  /** ± band around `rating` considered "optimal" difficulty (spec §9's elo-band shading). */
  optimalBand: number
}

export interface ClientProfile {
  role: string
  sprint: { current: number; total: number }
  goal: string
  /** Lowercase company slugs, rendered Title Case in the client header (§6). */
  targets: string[]
  elo: ClientElo
}

export const MOCK_CLIENT_PROFILE: ClientProfile = {
  role: 'Senior Frontend Engineer',
  sprint: { current: 14, total: 24 },
  goal: 'Staff-level offer at Google or Meta by April',
  targets: ['google', 'meta'],
  elo: { rating: 1520, optimalBand: 100 },
}
